import { render, staticRenderFns } from "./activar_desactivar_editoriales.vue?vue&type=template&id=8eb1b3c2"
import script from "./activar_desactivar_editoriales.vue?vue&type=script&lang=js"
export * from "./activar_desactivar_editoriales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports